import styled from 'styled-components';
import { isConstruction } from 'config';

export const StyledBackButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border: none;
  color: ${({ theme }) => theme.colors[isConstruction ? 'grey4' : 'grey6']};
  text-decoration: ${isConstruction ? 'underline' : 'none'};
  text-transform: ${isConstruction ? 'uppercase' : 'initial'};
  background-color: transparent;
  font-size: 18px;
  font-weight: ${isConstruction ? 'bold' : 'normal'};
  margin-bottom: 12px;
  cursor: pointer;

  img {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
`;
